export default __webpack_public_path__ + "media/src/assets/images/weekly-schedule_outlined-8ac9ece68f52a4fa4c6b5b9e900d718d.png";